import { ReactNode, useEffect } from 'react'
import { useAppSelector } from '../../redux/hooks'
import { useNavigate } from 'react-router-dom'
import { Wrapper } from '../../layouts/Wrapper'
import { GenericSpinner } from '../GenericSpinner/GenericSpinner'

interface NoAuthRouteProps {
    children?: ReactNode
}

export const NoAuthRoute = ({ children }: NoAuthRouteProps) => {

  const auth = useAppSelector(state => state.auth)
  const navigate = useNavigate()

  useEffect(() => {
    if (auth.data) {
      navigate('/')
    }
  }, [auth, navigate])

  if (auth.pending) {
    return <GenericSpinner />
  }

  if (auth.data) {
    return <Wrapper />
  }

  return children
}